// extracted by mini-css-extract-plugin
export var container = "_gt-0";
export var content = "_gt-3";
export var customerTitle = "_gt-4";
export var empty = "_gt-5";
export var gray = "_gt-6";
export var header = "_gt-7";
export var info = "_gt-8";
export var loading = "_gt-2";
export var loadingCard = "_gt-9";
export var oneLine = "_gt-a";
export var personName = "_gt-e";
export var pillContainer = "_gt-b";
export var selected = "_gt-1";
export var text = "_gt-c";
export var twoLines = "_gt-d";
export var unread = "_gt-f";
export var unreadIndicator = "_gt-g";